// extracted by mini-css-extract-plugin
export default {"icon":"panels_icon__+Sf6a","line":"panels_line__yyoWy","box":"panels_box__9Rp-Y","icon2":"panels_icon2__Bqs3W"};